module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_67.5deg.e6f5c2e0.png";